import { render, staticRenderFns } from "./TariffSetting.vue?vue&type=template&id=5abcde28&scoped=true&"
import script from "./TariffSetting.vue?vue&type=script&lang=ts&"
export * from "./TariffSetting.vue?vue&type=script&lang=ts&"
import style0 from "./TariffSetting.vue?vue&type=style&index=0&id=5abcde28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abcde28",
  null
  
)

export default component.exports